/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import tableCreatorCreatorFactoryCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import { DirectTableQueryBuilder } from "../../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder";
import { QueryVariable } from "../../../components/BPMTable/TableQueryBuilder/AbstractVariableStrategy";
import { InventoryClickStrategy } from '../../../components/BPMTable/TableMapperCreator'
import { InventoryTableCreator, InventoryQueries } from './InventoryTableCreator'

const UnvalidatedInventoryQueries = {
    ...InventoryQueries,
    tableQueryBuilder: new DirectTableQueryBuilder('unvalidatedInventoriesByInvoice')
}

class UnvalidatedInventoryTableCreator extends InventoryTableCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "UnvalidatedInventoryTableCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator = this.createTableCreator(this.constructor.getId(), tableName, UnvalidatedInventoryQueries, new InventoryClickStrategy())

        tableCreator.setVariables([
            new QueryVariable('invoice', 'String!')
        ]);

        tableCreator.addDescriptions(this.getFieldDescriptions())

        return tableCreator;
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(UnvalidatedInventoryTableCreator)

export {
    UnvalidatedInventoryTableCreator,
    UnvalidatedInventoryQueries
};
